import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';

const PossibleMatch = (match) => {
  if (resolve(match, 'params/target', false)) {
    return `match(target_id:${Number(resolve(match, 'params/target', null))}),`;
  }
  let selectedTargetId = match;
  if (typeof selectedTargetId == 'number') {
    return `match(target_id:${selectedTargetId}),`;
  }

  return '';
};

const employeesGroupQuery =  (params={}) => {
  const userParams = jsonToInputParams({
    limit: resolve(params, 'limit', 15),
    has_surveyed: true,
    sort_by: resolve(params, 'sort_by', 'first_name'),
    sort_order: resolve(params, 'sort_order', 'asc')
  });
  return HiringQuery(`
    {
      group (id: ${resolve(params, 'match/params/id', null)}) {
        id,
        name,
        archived,
        users(${userParams}) {
         pagination {
           limit
           offset
           total
         }
         results {
           name
           id
           first_name
           last_name,
           email,
           ${PossibleMatch(resolve(params, 'target', {}))}
           assessment {
             id,
             progress,
             completion_date,
             validity_score,
             validity_errors,
             scored
           }
         }
        }
        completed_assessments: users(limit: ${resolve(params, 'limit', 15)}, has_surveyed: true) {
         results {
           first_name,
           last_name,
           id,
           email,
           ${PossibleMatch(params.target)}
           assessment(completed: true) {
             id,
             validity_score,
             validity_errors,
             scored
           }
         }
        }
        assessment_stats {
         complete,
         ideal,
         incomplete,
         invalid,
         real,
         scored,
         valid
        }
      }
   }
  `);
};

const employeesGroupParseQuery = (data) => ({
  stats: resolve(data, 'group/assessment_stats', {}),
  employees: resolve(data, 'group/users/results', []),
  completed_assessments_users: resolve(data, 'group/completed_assessments/results', []),
  pagination: resolve(data, 'group/users/pagination', {}),
  group: resolve(data, 'group', {}),
  users: {
    pagination: resolve(data, 'group/users/pagination', {}),
    results: resolve(data, 'group/completed_assessments/results', []),
  },
  completed_assessments_chart: [{
    title: 'employees',
    color: 'pink',
    ids: resolve(data, 'group/completed_assessments/results', []).map(e=>e.assessment.id)
  }]
});

export { employeesGroupQuery, employeesGroupParseQuery };
